import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-card" }
const _hoisted_2 = { class: "modal-card-head" }
const _hoisted_3 = { class: "modal-card-title" }
const _hoisted_4 = { class: "modal-card-body modal-card-body-allow-overflow" }
const _hoisted_5 = {
  key: 0,
  class: "notification errors-notification is-danger"
}
const _hoisted_6 = { class: "modal-card-foot" }
const _hoisted_7 = ["disabled"]

import { ref } from "vue";
import type { Option } from "vue3-select-component";
import SingleSelect from "./fields/single-select.vue";
import VglistUtils from "../utils";
import Turbolinks from "turbolinks";

interface Props {
  game: { id: number; name: string };
  isActive: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'merge-games-modal',
  props: {
    game: { default: () => ({ id: 0, name: "" }) },
    isActive: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const errors = ref<string[]>([]);
const gameSelected = ref(false);
const gameA = ref<Option<number> | null>(null);

function onClose() {
  emit("close");
}

function onSave() {
  if (!gameA.value) {
    errors.value = ["Please select a game"];
    return;
  }

  const gameAId = gameA.value.value; // Extract ID from Option format
  const gameBId = props.game.id;
  const mergePath = `/games/${gameAId}/merge/${gameBId}.json`;

  VglistUtils.rawAuthenticatedFetch(mergePath, "POST").then((response) => {
    // HTTP 301 response
    if (response.redirected) {
      Turbolinks.clearCache();
      Turbolinks.visit(response.url);
      // If it's not a redirect, check it for errors and display them.
    } else {
      response.json().then((json) => {
        errors.value = json.errors;
      });
      const submitButton = document.querySelector(".js-submit-button");
      if (submitButton) {
        submitButton.classList.add("js-submit-button-error");
        setTimeout(() => {
          submitButton.classList.remove("js-submit-button-error");
        }, 2000);
      }
    }
  });
}

function selectGame() {
  gameSelected.value = true;
}

// Include the vglist ID in the dropdown to help distinguish between games
// that have the same name.
function customOptionLabel(item: { id: number; name: string }): Option<number> {
  return { value: item.id, label: `${item.name} (${item.id})` };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", { 'is-active': __props.isActive }])
  }, [
    _createElementVNode("div", {
      onClick: onClose,
      class: "modal-background"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(`Merge ${__props.game.name} into another game`), 1),
        _createElementVNode("button", {
          onClick: onClose,
          class: "delete",
          "aria-label": "close"
        })
      ]),
      _createElementVNode("section", _hoisted_4, [
        (errors.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(errors.value.length > 1 ? "Errors" : "An error") + " prevented this game from being merged: ", 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                  return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(SingleSelect, {
            label: 'Game',
            modelValue: gameA.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((gameA).value = $event)),
              selectGame
            ],
            "search-path-identifier": 'games',
            customOptionFunc: customOptionLabel
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("footer", _hoisted_6, [
        _createElementVNode("button", {
          onClick: onSave,
          class: "button is-primary js-submit-button",
          disabled: !gameSelected.value
        }, " Submit ", 8, _hoisted_7),
        _createElementVNode("button", {
          onClick: onClose,
          class: "button"
        }, "Cancel")
      ])
    ])
  ], 2))
}
}

})